import script from "./OrderCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderCard.vue?vue&type=script&lang=ts&setup=true"

import "./OrderCard.vue?vue&type=style&index=0&id=3373f70d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3373f70d"]])

export default __exports__